import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/Main.vue";
import store from "@/store/index";
import { StoreModule } from "@/store/types";
import { UserGetters } from "@/store/modules/user/types";
import { Roles } from "@/models/roles";
import { AuthError } from "@/services/error_service";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/landing/NotFound.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/landing/Error.vue"),
  },
  {
    path: "/",
    component: Main,
    children: [
      {
        path: "",
        name: "repslist",
        component: () => import("../components/Sidebar/Rep/RepList.vue"),
        beforeEnter(to, from, next) {
          const state = store;
          const user = state.getters[StoreModule.User + UserGetters.GetUser];
          const role = user && user.role ? user.role : null;
          if (role === Roles.SalesRep) {
            // Redirects reps to their profile
            next({ path: "/reps/" + 'me' });
          } else {
            next();
          }
        },
      },
      {
        path: "/customers",
        name: "customerslist",
        component: () =>
          import("../components/Sidebar/Customer/CustomerList.vue"),
          beforeEnter(to, from, next) {
              const state = store;
              const user = state.getters[StoreModule.User + UserGetters.GetUser];
              const role = user && user.role ? user.role : null; 
              if (
                role === Roles.SalesRep &&
                (!to.query.region || to.query.region != user.rep_info.sales_region)
              ) {
                // Redirects reps to their assigned region
                const searchTerm = to.query && to.query.search ? to.query.search as string : null
                next({ path: "/customers", query: { region: user.rep_info.sales_region, search: searchTerm } });
              } else {
                next();
              }
          }
      },
      {
        path: "/customers/:id",
        name: "customers",
        component: () =>
          import("../components/Sidebar/Customer/SingleCustomer.vue"),
      },
      {
        path: "/reps/:id",
        name: "reps",
        component: () => import("../components/Sidebar/Rep/SingleRep.vue"),
      },
    ],
  },
  {
    path: "/login",
    beforeEnter(to, from, next) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace(
        `${process.env.VUE_APP_LOGIN_URL}?returnURL=${process.env.VUE_APP_URL}`
      );
      // window.location.replace('http://localhost:8080?returnURL=http://localhost:8083')
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});



export default router;
